export default {"src":"/_next/static/media/pencil_white.9749d106.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};